<template>
  <div
    class="w-full relative border border-solid rounded-lg"
    :class="{
      'text-white text-sm border-grey-700': hasState('dark'),
      'text-grey-600 border-grey-200': !hasState('dark')
    }"
  >
    <textarea
      ref="input"
      :placeholder="placeholder"
      :value="value"
      class="w-full h-full outline-none rounded-lg px-2 resize-none py-2"
      :class="{
        'bg-grey-800': hasState('dark'),
        'bg-white': !hasState('dark')
      }"
      style="min-height:200px;"
      @input="onInput"
      @keyup="keyup"
      @keydown="keydown"
    ></textarea>
  </div>
</template>

<script>
import mixins from '../mixins';
export default {
  name: 'EmbedArea',
  mixins: [mixins],
  props: ['value', 'placeholder', 'dark'],
  methods: {
    onInput() {
      this.$emit(
        'input',
        this.$refs.input.value.replace(/\\([\s\S])|("|\/)/gi, '\\$1$2')
      );
    },
    keyup() {
      this.$emit(
        'input',
        this.$refs.input.value.replace(/\\([\s\S])|("|\/)/gi, '\\$1$2')
      );
      this.$emit(
        'keyup',
        this.$refs.input.value.replace(/\\([\s\S])|("|\/)/gi, '\\$1$2')
      );
    },
    keydown(e) {
      this.$emit('keydown', e);
    }
  }
};
</script>
